module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Home-heart-d9e527ce966f9bd64188935d8ebaf0e1.svg";